import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedStratalotAssociationApiService } from './stratalot-association-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class StratalotAssociationApiService extends GeneratedStratalotAssociationApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
